// WhatWeDoNotChargeFor.js
import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';

const WhatWeDoNotChargeFor = () => {
  const exclusions = [
    'Admission letters',
    'Job offers',
    'Scholarships or tuition discounts',
    'Visa approvals',
    'Tuition or salary payments'
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
              What We Do Not Charge For
            </h2>
            <p className="text-gray-600 text-base font-light leading-relaxed">
              To ensure full transparency, Notapaths does not charge for:
            </p>
          </motion.div>

          {/* Exclusions List */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-[#F5F8FA] p-8 rounded-lg mb-6"
          >
            <div className="space-y-4">
              {exclusions.map((exclusion, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                  className="flex items-start gap-3"
                >
                  <X size={20} className="text-red-500 flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 text-base font-light">
                    {exclusion}
                  </p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Bottom Statement */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="text-center"
          >
            <p className="text-gray-700 text-base font-normal">
              Our pricing is transparent and focused on the support services we provide.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDoNotChargeFor;
